import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Animation} from "./Shot";
import {AnimationType} from "../../routes/common/Animations";
import {host} from "./api";


export interface AnimationsState {
    animations?: Array<Animation>,
    status: Status,
    error: string | null | undefined
}

const initialState: AnimationsState = {
    animations: [],
    status: Status.Idle,
    error: null,
}

export const fetchAnimations = createAsyncThunk('animations', async (params: { projectId: number, animationType: AnimationType }) => {
    const response = await axios.get(`${host}/animations/type/${params.animationType}`, {
        headers: headers(params.projectId.toString())
    })
    return response.data
})

export const saveAnimation = createAsyncThunk('saveAnimation', async (params: { projectId: number, layerId: number, animation: Animation }) => {
    const response = await axios.post(`${host}/layers/${params.layerId}/animations`,
        params.animation,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveCharacterAnimation = createAsyncThunk('saveCharacterAnimation', async (params: { projectId: number, characterId: number, animation: Animation }) => {
    const response = await axios.post(`${host}/characters/${params.characterId}/animations`,
        params.animation,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveObjectAnimation = createAsyncThunk('saveObjectAnimation', async (params: { projectId: number, objectId: number, animation: Animation }) => {
    const response = await axios.post(`${host}/objects/${params.objectId}/animations`,
        params.animation,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const saveLocationAnimation = createAsyncThunk('saveLocationAnimation', async (params: { projectId: number, locationId: number, animation: Animation }) => {
    const response = await axios.post(`${host}/locations/${params.locationId}/animations`,
        params.animation,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const unsetAnimation = createAsyncThunk('unsetAnimation', async (params: { projectId: number, layerId: number, animationId: number }) => {
    const response = await axios.delete(`${host}/layers/${params.layerId}/animations/${params.animationId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteAnimation = createAsyncThunk('deleteAnimation', async (params: { projectId: number, animationId: number }) => {
    const response = await axios.delete(`${host}/animations/${params.animationId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const animationsSlice = createSlice({
    name: 'animations',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchAnimations.pending, (state, action) => {
                state.animations = []
                state.status = Status.Loading
            })
            .addCase(fetchAnimations.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.animations = action.payload
            })
            .addCase(fetchAnimations.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
            .addCase(saveAnimation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveAnimation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(unsetAnimation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(unsetAnimation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveCharacterAnimation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveCharacterAnimation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveObjectAnimation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveObjectAnimation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveLocationAnimation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveLocationAnimation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteAnimation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteAnimation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
    }
})
export default animationsSlice.reducer;